import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse,
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const studentHolidayAPI = createApi({
    reducerPath: 'studentHolidayAPI',
    baseQuery: defaultBaseQuery,
    tagTypes: ['StudentHoliday'],
    endpoints: (builder) => ({

        addStudentHoliday: builder.mutation({
            query: (data) => ({
                url: 'holiday',
                method: 'POST',
                body: data
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ['StudentHoliday']
        }),

        updateStudentHoliday: builder.mutation({
            query: ({ holidayId, ...data }) => ({
                url: `holiday/${holidayId}`,
                method: 'PUT',
                body: data
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ['StudentHoliday']
        }),

        getStudentHolidayList: builder.query({
            query: ({ page = 0, size = 10 } = {}) => ({
                url: 'holiday',
                method: 'GET',
                params: { page, size }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ['StudentHoliday']
        }),

        getStudentHolidayById: builder.query({
            query: (holidayId) => ({
                url: `holiday/${holidayId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteStudentHoliday: builder.mutation({
            query: (holidayId) => ({
                url: `holiday/${holidayId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ['StudentHoliday']
        }),

    })
});

export const {
    useAddStudentHolidayMutation, useUpdateStudentHolidayMutation,
    useGetStudentHolidayListQuery, useLazyGetStudentHolidayByIdQuery,
    useDeleteStudentHolidayMutation,
} = studentHolidayAPI;

export default studentHolidayAPI;
